module.exports = __webpack_public_path__ + "img/ModularWallV2.632e4410.jpg";